module.exports = __webpack_public_path__ + "static/media/instagram-d.d23cade3.svg";